// removed by extract-text-webpack-plugin
module.exports = {"commentLabel":"gViu0JcSvowu_tjYczoz","confirmWarning":"_1PHFHp-YVxREr1Vm6DctOH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReopenTransferForm/styles.css
// module id = 3218
// module chunks = 0